import React, { useEffect, useState } from "react";
import { Spin, Tag } from "antd";
import aiConsoleService from "services/aiconsoleservice";
import AgentDetail from "./AgentDetail";

const StatusBadge = ({ status }) =>
  status === "editable" ? (
    <Tag color="green">Editable</Tag>
  ) : (
    <Tag color="default">Coming soon</Tag>
  );

const Agents = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    aiConsoleService
      .getAgents()
      .then((res) => {
        setAgents(res?.data ?? []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (selected) {
    return <AgentDetail agentKey={selected} onBack={() => setSelected(null)} />;
  }

  if (loading) return <div className="p-8 flex justify-center"><Spin /></div>;

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {agents.map((a) => (
        <button
          key={a.agent_key}
          type="button"
          data-testid={`agent-card-${a.agent_key}`}
          onClick={() => setSelected(a.agent_key)}
          className="text-left rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 hover:border-emerald-400 transition focus:outline-none focus:ring-2 focus:ring-emerald-500"
        >
          <div className="flex items-center justify-between gap-2">
            <span className="font-medium text-slate-800 dark:text-white">{a.display_name}</span>
            <StatusBadge status={a.status} />
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{a.description}</p>
        </button>
      ))}
    </div>
  );
};

export default Agents;
